import { PathItemsQueryDocument } from "@pathwright/graphql-client/src/generated"
import { createPaginator, flattenEdges } from "../../../utils/apollo"
import { createPathFromItems } from "../../utils"
import { graphql } from "@apollo/client/react/hoc"
import get from "lodash/get"

export const PathQuery = PathItemsQueryDocument

export default graphql(PathQuery, {
  // requires path id
  options: ({ pathId, schoolId }) => ({
    variables: {
      id: pathId,
      school_id: schoolId
    }
  }),
  // map data to props
  props: ({ data }) => {
    const { error, loading } = data
    return {
      error,
      loading,
      items: createPathFromItems(
        flattenEdges(get(data, "context.school.pathItems") || [])
      ),
      hasMore: get(data, "context.school.pathItems.pageInfo.hasNextPage"),
      loadMore: createPaginator(data, "context.school.pathItems")
    }
  }
})
